export enum TipoParametro {
    TEXTO = 'Texto',
    NUMERO = 'Número',
    FECHA = 'Fecha',
}
